import { render, staticRenderFns } from "./plan-b.vue?vue&type=template&id=8df14506&scoped=true"
import script from "./plan-b.vue?vue&type=script&lang=js"
export * from "./plan-b.vue?vue&type=script&lang=js"
import style0 from "./plan-b.vue?vue&type=style&index=0&id=8df14506&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df14506",
  null
  
)

export default component.exports